import React, { useState } from 'react';
import './CarDetailsOverlay.css';
import { FaTimes } from 'react-icons/fa';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Class E images
import classE1 from '../assets/cars/class_e_220/1.png';
import classE2 from '../assets/cars/class_e_220/2.png';
import classE3 from '../assets/cars/class_e_220/3.png';
import classE4 from '../assets/cars/class_e_220/4.png';

// Break images
import break1 from '../assets/cars/class_e_220_break/1.png';
import break2 from '../assets/cars/class_e_220_break/2.png';
import break3 from '../assets/cars/class_e_220_break/3.png';
import break4 from '../assets/cars/class_e_220_break/4.png';

// Class V images
import classV1 from '../assets/cars/class_v/1.png';
import classV2 from '../assets/cars/class_v/2.png';
import classV3 from '../assets/cars/class_v/3.png';
import classV5 from '../assets/cars/class_v/5.jpg';

// Prius images
import prius1 from '../assets/cars/prius/1.PNG';
import prius2 from '../assets/cars/prius/2.PNG';
import prius3 from '../assets/cars/prius/3.PNG';
import prius4 from '../assets/cars/prius/4.PNG';

function CarDetailsOverlay({ car, onClose }) {
  // Create an array of images based on the car model
  const getCarImages = () => {
    switch (car.id) {
      case 'mercedes_class_e':
        return [
          { id: 1, src: classE1 },
          { id: 2, src: classE2 },
          { id: 3, src: classE3 },
          { id: 4, src: classE4 }
        ];
      case 'mercedes_class_e_break':
        return [
          { id: 1, src: break1 },
          { id: 2, src: break2 },
          { id: 3, src: break3 },
          { id: 4, src: break4 }
        ];
      case 'mercedes_class_v':
        return [
          { id: 1, src: classV1 },
          { id: 2, src: classV2 },
          { id: 3, src: classV3 },
          { id: 5, src: classV5 }
        ];
      case 'toyota_prius':
      case 'toyota_prius_plus':
        return [
          { id: 1, src: prius1 },
          { id: 2, src: prius2 },
          { id: 3, src: prius3 },
          { id: 4, src: prius4 }
        ];
      default:
        return [{ id: 1, src: car.image }];
    }
  };

  const allImages = getCarImages();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? allImages.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => 
      prev === allImages.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="overlay">
      <div className="overlay-content">
        <button className="close-button" onClick={onClose}>
          <FaTimes />
        </button>
        <h2>{car.model}</h2>
        
        <div className="main-image-container">
          <button className="nav-button prev" onClick={handlePrevImage}>
            <FaChevronLeft />
          </button>
          <img src={allImages[currentImageIndex].src} alt={car.model} />
          <button className="nav-button next" onClick={handleNextImage}>
            <FaChevronRight />
          </button>
        </div>

        <div className="thumbnails-grid">
          {allImages.map((image, index) => (
            <div 
              key={image.id}
              className={`thumbnail-container ${index === currentImageIndex ? 'active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            >
              <img src={image.src} alt={`${car.model} view ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CarDetailsOverlay; 